import { configureStore } from "@reduxjs/toolkit";
import accountSlice from "./accountSlicer";
import candidateSkillSetsSlice from "./candidateSkillSetsSlicer";
import candidateSlice from "./candidateSlicer";
import experienceDetailSlice from "./experienceDetailSlicer";
import familyDetailSlice from "./familyDetailSlicer";
import interviewRoundSlice from "./interviewRoundSlicer";
import locationSlice from "./locationSlicer";
import qualificationSlice from "./qualificationSlicer";
import referenceSlice from "./referenceSlicer";
import requisitionSlice from "./requisitionSlicer";
import roleSlice from "./roleSlicer";
import skillSetMasterSlice from "./skillSetMasterSlicer";
import sourceSlice from "./sourceSlicer";
import showAllReducer from "./calendarSlice";

export const store = configureStore({
  reducer: {
    requisition: requisitionSlice,
    accounts: accountSlice,
    candidates: candidateSlice,
    locations: locationSlice,
    candidateskillsets: candidateSkillSetsSlice,
    interviewRounds: interviewRoundSlice,
    skillSetMaster: skillSetMasterSlice,
    interviewNotes: interviewRoundSlice,
    sourceMaster: sourceSlice,
    roleMaster: roleSlice,
    experienceDetail: experienceDetailSlice,
    familyDetail: familyDetailSlice,
    reference: referenceSlice,
    qualification: qualificationSlice,
    showAll: showAllReducer,
  },
});
